module.exports = __webpack_public_path__ + "img/performance.a0fe5b81.png";